import React, { useRef, useState } from 'react'
import { CallBoth } from '~/service/SipConn'
import { play, Signal, stop } from '~/utils/sound'

type Props = {
  call: CallBoth
}

const Keypad: React.FC<Props> = ({ call }) => {
  const callRef = useRef(call)
  callRef.current = call

  const [value, setValue] = useState('')

  const valueRef = useRef(value)
  const setValueRef = useRef(setValue)

  valueRef.current = value
  setValueRef.current = setValue

  const onClick = (signal: Signal) => {
    setValueRef.current(valueRef.current + signal)
    callRef.current?.sendDtmf(signal)

    play(signal)
    setTimeout(stop, 100)
  }

  return (
    <div className="phone-keypad is-inCall">
      <div className="phone-keypad-value">{value}</div>

      <div className="phone-keypad-buttons">
        <div>
          <Button val="1" onClick={onClick} />
          <Button val="2" onClick={onClick} />
          <Button val="3" onClick={onClick} />
        </div>
        <div>
          <Button val="4" onClick={onClick} />
          <Button val="5" onClick={onClick} />
          <Button val="6" onClick={onClick} />
        </div>
        <div>
          <Button val="7" onClick={onClick} />
          <Button val="8" onClick={onClick} />
          <Button val="9" onClick={onClick} />
        </div>
        <div>
          <Button val="*" onClick={onClick} />
          <Button val="0" onClick={onClick} />
          <Button val="#" onClick={onClick} />
        </div>
      </div>
    </div>
  )
}

export default Keypad

type ButtonProps = {
  val: Signal
  onClick: (signal: Signal) => void
}

const Button: React.FC<ButtonProps> = ({ val, onClick }) => {
  return <button onClick={() => onClick(val)}>{val}</button>
}
